import { useDispatch, useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useState } from "react";
import {
  useGetSubscriptionAccessListDataQuery,
  useUpdateSubscriptionAccessTableHeadDataMutation,
} from "../../../store/queries/CMS";
import { getFormatedDate } from "../../../utils/Functions/table";
import { toast } from "react-toastify";
import { viewSubscriptionAccess } from "./api";

const useSubscriptionAccess = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];

  const dispatch = useDispatch();
  const { showEditModal } = useSelector((state) => state.global);

  const [subscriptionAccessState, setSubscriptionAccessState] = useState({
    currentPageSize: 10,
    currentPage: 1,
    search: "",
    sortBy: "",
    sortOrder: "desc",
    itemId: "",
    showModal: false,
    itemData: "",
    tableFeilds: {},
  });

  const {
    data: subscriptionAccessList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetSubscriptionAccessListDataQuery({
    page_size: subscriptionAccessState?.currentPageSize,
    page: subscriptionAccessState?.currentPage,
    search: subscriptionAccessState?.search,
    sort_by: subscriptionAccessState?.sortBy,
    sort_order: subscriptionAccessState?.sortOrder,
  });

  const [updateSubscriptionAccessTableHeadData] =
    useUpdateSubscriptionAccessTableHeadDataMutation();

  const handleSearch = (e) => {
    setSubscriptionAccessState((prev) => ({
      ...prev,
      search: e?.target?.value,
      currentPage: 1,
    }));
  };

  const handleClearClick = () => {
    setSubscriptionAccessState((prev) => ({
      ...prev,
      search: "",
      currentPage: 1,
    }));
  };

  const handleSort = (label) => {
    if (subscriptionAccessState?.sortBy === label) {
      setSubscriptionAccessState((prev) => ({
        ...prev,
        currentPage: 1,
        sortOrder: prev.sortOrder === "asc" ? "desc" : "asc",
      }));
    } else {
      setSubscriptionAccessState((prev) => ({
        ...prev,
        currentPage: 1,
        sortBy: label,
        sortOrder: "asc",
      }));
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data?.[field]}</p>,
      status: (field, data) =>
        data?.status === 1 ? (
          <span className={"pro-badge badge-primary-outline"}>{"Active"}</span>
        ) : data?.status === 2 ? (
          <span className={"pro-badge badge-danger-outline"}>
            {"Deactivated"}
          </span>
        ) : (
          data?.status
        ),
      user_mobiles: (field, data) => {
        if (data?.eligibility_type === "open") {
          return (
            <span className={"pro-badge badge-primary-outline"}>
              Everyone
            </span>
          );
        }
        return (
          <p className="pro-mb-0">
            {data?.[field]?.map((num, i) => (
              <span key={i}>
                {num}
                {i !== data[field].length - 1 ? ", " : ""}
              </span>
            ))}
          </p>
        );
      },
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleEditAction = (id) => {
    const itemId = id?.[0];
    viewSubscriptionAccess(itemId).then((res) => {
      if (res?.data?.status_code === 200) {
        setSubscriptionAccessState((prev) => ({
          ...prev,
          itemId: itemId,
          itemData: res?.data?.data,
          showModal: true,
        }));
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const handlePagination = (page) => {
    setSubscriptionAccessState((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const handlePageSize = ({ value: page_size }) => {
    setSubscriptionAccessState((prev) => ({
      ...prev,
      currentPageSize: page_size,
      currentPage: 1,
    }));
  };

  const closeModal = () => {
    setSubscriptionAccessState((prev) => ({
      ...prev,
      itemData: "",
      showModal: false,
    }));
  };

  return {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    subscriptionAccessList,
    subscriptionAccessState,
    handleEditAction,
    closeModal,
    setSubscriptionAccessState,
    updateSubscriptionAccessTableHeadData,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useSubscriptionAccess;
